<div class="main-select">
    <div class="main-select-button">
        <input (change)="readSingleFile($event)" [attr.accept]="fileExtension"
               class="main-select-button-input" type="file"/>
        <span>{{"wbo.common.button.selectFile" | translate}}</span>
    </div>
    <div class="main-select-filename">
        {{fileName ? fileName : 'wbo.common.file-upload.label.noFileChosen' | translate}}
    </div>
</div>
